<template>
  <div id="app">
    <router-view v-if="shox" :api_token='api_token' :agency_id='agency_id'/>
    <sho></sho>
    <div  class="coupon_general" style="position: fixed;z-index: 99;top: 0;width: 100%;height: 100vh;background: rgba(0,0,0,.6);"  v-if="coupon_general_show" @click="coupon_gen_click">
      <div style="width: 100%;height: 100%; display: block;position: absolute;top: 0;bottom: 0;left: 0; right: 0; margin: auto;">
          <div style="width: 6.3rem;height: 7rem;position: absolute;top: 0;bottom: 0;left: 0; right: 0; margin: auto;" class="coupon_general_button" @click.stop="coupon_general_click">
              <img src="https://fview.5kjs.com/wap_img/newShool/product/detail/coupon_01.png" alt="" style="max-width: 100%;">
          </div>
          <div class="coupon_general" style="width: .6rem;height: .6rem;position: absolute;bottom: 20vh;left: 45vw; margin: auto;">
              <img src="https://fview.5kjs.com/wap_img/newShool/product/detail/coupon_02.png" style="max-width: .6rem"/>
          </div>
      </div>
    </div>

    <div class="coupon_general_popup" style="width: 100vw;height: 100vh;position: fixed !important;z-index: 99 !important;top: 0;" v-if="coupon_show" @click="coupon_show = false">
      <!-- 恭喜你领取成功 第二种情况-->
      <div class="coupon_general_popup_top" style="width: 5.26rem;height: 6.26rem;position: absolute;right: 0;left: 0; bottom: 0;top: 0;margin: auto;">
          <img src="https://www.jszg.com/wap/images/coupon_success2.png" style="width: 5.26rem;height: 6.26rem;">
          <div class="coupon_general_popup_top_flex" style="display: flex;justify-content: space-around;width: 100%;position: absolute;bottom: 0.43rem;">
              <a href="/m/productcentre" style="width: 2.21rem;height: 0.77rem;background: #E83D3B;border-radius: 0.1rem;text-align: center; color: #FFF;line-height: .77rem;font-size: .24rem;">去使用</a>
              <a href="/m/coupon_list" style="width: 2.21rem;height: 0.77rem;background: #FFFFFF;border: 1px solid #E83D3B;border-radius: 0.1rem;text-align: center;color: #E83D3B;line-height: .77rem;font-size: .24rem;">查看优惠券</a>
          </div>
      </div>

      <div class="coupon_general_popup_i" style="width: 0.61rem;height: 0.61rem; border-radius: 50%;position: absolute;right: 0;left: 0;margin: auto; bottom: 20vh;text-align: center; line-height: .61rem;">
          <img src="https://fview.5kjs.com/wap_img/newShool/product/detail/coupon_02.png" style="max-width: .61rem"/>
      </div>

      <div class="coupon_general_popup_bac" style="width: 100vw; height: 100vh;background: rgba(0,0,0,.86);"></div>
    </div>
  </div>
</template>

<script>
var than;
import Cookie from 'js-cookie'
import sho from "./components/sho.vue";
export default {
  name: "app",
  components: { sho },
  provide() {
    return {

    };
  },
  data() {
    return {
      http:'https:' == document.location.protocol ? 'https://': 'http://',
      api_token:'',
      agency_id:'',
      shox:false,
      coupon_general_show: false,
      coupon_show: false,
    };
  },
  created() {
      than = this
      this.getAgencyInfo()
      sessionStorage.setItem('exam_tab', '115')
      sessionStorage.setItem('exam_name', '教师招聘')
      // 自动判断当前环境
      var thisUrl = window.location.origin
      let config = {
        // 正式服
        baseURL: "https://apinew.5kjs.com/activity.query_score/"
      };

      if (thisUrl.search(/test2.5kjs/g) != -1) {
          config.baseURL = "http://apinew2.5kjs.com/activity.query_score/"
      } else if (thisUrl.search(/test.5kjs/g) != -1) {
          config.baseURL = "http://apinew2.5kjs.com/activity.query_score/"
      } else if (thisUrl.search(/xueba.com/g) != -1) {
          config.baseURL = "http://apinew.xueba.com/activity.query_score/"
      } else if (thisUrl.search(/xueba.hk/g) != -1) {
          config.baseURL = "http://apinew.xueba.com/activity.query_score/"
      } else if (thisUrl.search(/localhost:/g) != -1) {
          config.baseURL = "http://apinew.xueba.com/activity.query_score/"
      } else {
          config.baseURL = "https://apinew.5kjs.com/activity.query_score/"
      }
      // config.baseURL = "https://apinew.5kjs.com/activity.query_score/"

      // if(Cookie.get("api_token") == undefined) {
      //   this.api_token = ""
      // }else {
        // this.api_token = Cookie.get("api_token")
      // }
      var than = this
      if(this.$route.query.sign != undefined) {
        $.get(config.baseURL + 'loginJump', { sign:this.$route.query.sign, agency_id:localStorage.getItem('agency_id') }, function(result) {
            than.shox = true
            if (result.code == 200) {
              than.api_token = result.data.token
              if(result.data.is_new_people > 0) {
                than.coupon_general_show = true
              }
              localStorage.setItem('api_token', than.api_token)
              window.location.href = window.location.origin + '/activity/written/#/index' 
              than.api_token = Cookie.get('api_token')
            }else {
              // than.api_token = Cookie.get('api_token')
              than.api_token =  localStorage.getItem('api_token')
              // than.$toast(result.message)
            }
        })
      }
      
      if(Cookie.get("api_token") != undefined){
        $.get(config.baseURL + 'loginJump', { sign: Cookie.get("api_token"), agency_id:localStorage.getItem('agency_id') }, function(result) {
            than.shox = true
            if (result.code == 200) {
              than.api_token = result.data.token
              if(result.data.is_new_people > 0) {
                than.coupon_general_show = true
              }
              localStorage.setItem('api_token', than.api_token)
              than.api_token =  localStorage.getItem('api_token')
              // than.api_token = result.data.token
            }else {
              // than.api_token = Cookie.get('api_token')
              than.api_token =  localStorage.getItem('api_token')
            }
        })
      }
      
      if(this.$route.query.sign == undefined || Cookie.get("api_token") == undefined) {
        than.shox = true
      }
  },
  methods: {
    //领取成功
    coupon_general_click() {
      var than = this
      $.get(config.baseURL + 'getCoupon', { sign: Cookie.get("api_token") }, function(result) {
          if (result.code == 200) {
            than.coupon_general_show = false
            than.$toast('领取成功')
            than.coupon_show = true
          }else {
            than.$toast(result.message)
          }
      })
    },
    //关闭
    coupon_gen_click() {
      var than = this
      $.get(config.baseURL + 'resettingNewPeople', { sign: Cookie.get("api_token") }, function(result) {
          if (result.code == 200) {
            than.coupon_general_show = false
          }else {
            than.$toast(result.msg)
          }
      })
    },
    getAgencyInfo() {
      this.$axios.get('getAgencyInfo', {params:{ domain: window.location.host == 'localhost:8080' ? 'www.jszg.com' : window.location.host}}).then((d)=> {
          if(d.code == 200) {
            this.agency_id = d.data.agency_id
            localStorage.setItem("agency_id", d.data.agency_id);
            localStorage.setItem("path", d.data.path);
            localStorage.setItem("data_inof", JSON.stringify(d.data));
          }else {
            this.$toast(d.message)
          }
      }).catch((err) => {
          // this.$toast(err)
      });
    }
  },
  mounted() {
   
  },
};

// 自动判断当前环境
var thisUrl = window.location.origin
let config = {
  // 正式服
  baseURL: "https://apinew.5kjs.com/activity.query_score/"
};

if (thisUrl.search(/test2.5kjs/g) != -1) {
    config.baseURL = "http://apinew2.5kjs.com/activity.query_score/"
} else if (thisUrl.search(/test.5kjs/g) != -1) {
    config.baseURL = "http://apinew2.5kjs.com/activity.query_score/"
} else if (thisUrl.search(/xueba.com/g) != -1) {
    config.baseURL = "http://apinew.xueba.com/activity.query_score/"
} else if (thisUrl.search(/xueba.hk/g) != -1) {
    config.baseURL = "http://apinew.xueba.com/activity.query_score/"
} else if (thisUrl.search(/localhost:/g) != -1) {
    config.baseURL = "http://apinew.xueba.com/activity.query_score/"
} else {
    config.baseURL = "https://apinew.5kjs.com/activity.query_score/"
}

// var sign = getUrlParam('sign');
// console.log(window.location)
// console.log(sign)

// $.get(config.baseURL + 'loginJump', { sign:sign, agency_id:localStorage.getItem('agency_id') }, function(result) {
//     window.location.href = window.location.origin
// })
</script>

<style lang="less">
    @import url("./assets/common/public.css");
    @import url("./assets/common/fonts.css");
    @import url("https://at.alicdn.com/t/font_2850911_xc9xcbb69l.css");
    @import url("https://at.alicdn.com/t/font_2850911_tj9bsowcdds.css");
    @import url("./assets/common/fontFamily.css");

    .van-toast__text {
      font-size: .3rem;
    }

    a{
      cursor: pointer;
    }

    .van-toast--text {
      padding: .2rem !important;
    }

    #app > div {
      width: 7.5rem;
      position: relative;
      margin: 0 auto;
    }

    a {
        cursor: pointer;
    }

    .ellipsis{
      white-space: nowrap;
      text-overflow:ellipsis;
      white-space:nowrap;
    }

    p {
      margin: 0;
    }
</style>
